/* 🤖 this file was generated by svg-to-ts */
export const matIconAddPhotoAlternate: {
  name: 'add-photo-alternate';
  data: string;
} = {
  name: 'add-photo-alternate',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"/></svg>`
};
